import { apiFetch } from './apiClient';

export type OrganizationChartNodeItem = {
  id: number;
  parentId?: number | null;
  accountId?: number | null;
  firstName?: string | null;
  lastName?: string | null;
  email?: string | null;
  profilePhoto?: string | null;
  positionTitle: string;
  department: string;
  colorHex: string;
  children: OrganizationChartNodeItem[];
};

export type OrganizationChartNodePayload = {
  accountId?: number | null;
  parentId?: number | null;
  positionTitle: string;
  department: string;
  colorHex: string;
};

export const getOrganizationChart = (): Promise<OrganizationChartNodeItem[]> =>
  apiFetch('/organization-chart');

export const createOrganizationChartNode = (
  payload: OrganizationChartNodePayload,
): Promise<OrganizationChartNodeItem> =>
  apiFetch('/organization-chart/nodes', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });

export const updateOrganizationChartNode = (
  id: number,
  payload: OrganizationChartNodePayload,
): Promise<OrganizationChartNodeItem> =>
  apiFetch(`/organization-chart/nodes/${id}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });

export const deleteOrganizationChartNode = (id: number): Promise<void> =>
  apiFetch(`/organization-chart/nodes/${id}`, {
    method: 'DELETE',
  });

const OrganizationChartService = {
  getOrganizationChart,
  createOrganizationChartNode,
  updateOrganizationChartNode,
  deleteOrganizationChartNode,
};

export default OrganizationChartService;
